import { Spin, message as AndMessage } from "antd";
import { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import { sendverifysms, login } from "../../../fetch/api/login";

let secondInterval = null;
const VerificationCode = ({
  setAvatar,
  BackAccountNumber,
  props,
  toInformation,
}) => {
  const [loading, setLoading] = useState(false);
  const { phoneValue, nationText } = props;
  const [seconds, setSeconds] = useState(60);
  useEffect(() => {
    return () => {
      setSeconds(60);
      secondInterval && clearInterval(secondInterval);
    };
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      secondInterval && clearInterval(secondInterval);
    } else if (seconds === 60) {
      secondInterval && clearInterval(secondInterval);
      secondInterval = setInterval(() => {
        setSeconds((n) => {
          if (n === 60) {
            numberLogin();
          }
          return n - 1;
        });
      }, 1000);
    }
  }, [seconds]);

  const [code, setCode] = useState([
    { num: "" },
    { num: "" },
    { num: "" },
    { num: "" },
  ]);
  const [activeInput, setactiveInput] = useState(0);

  function numberLogin() {
    let encryptioncode = encryption({
      country_code: nationText,
      cellphone: phoneValue,
    });
    sendverifysms(encryptioncode).then((res) => {
      const { code, message } = res;
      if (code == 200) {
      } else {
        AndMessage.error({
          content: message,
          maxCount: 1,
        });
      }
    });
  }
  // 开始加密
  function encryption(formData) {
    let code = generateRandomStr();
    let time = new Date().getTime();
    let AES = encrypt(code, JSON.stringify(formData));
    let codes = `biz_content=${AES}&check=${code}&ts=${time}`;
    let SHA1 = CryptoJS.SHA1(codes).toString();
    let MD5 = CryptoJS.MD5(SHA1).toString().toUpperCase();
    let publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3JgeYQCU/G6AqQI28vVRXwFZZK25J8PxC1xFSwHIFGIY/tEeZpnihO92mF4r4V9h4n79bcxheGUVGJv/xC/Y9hnIYV0UE+acSQtaJ/nZZSh8DmLYDKZ9+CZBMW8PjHGqelxZxgx8RRH/mUefvnupWqeASwmgEWR+dLt3N04pdr02hJfBJ9s0EKqJR0Sscj90Qpr079/4ZkoeeEOqM5/PlvfZXzWdwktd8s9zdAIisOKDJWbJBPbJGpRp+lHj/lSL1iPvXxDp24klODi7T/rLD3WDZ3nS7c1TCZRVAqLfc4xHCuCHY5lwIqjxM4tcE8cRaThm4Lwa5+xJ8LE6t+ZP/QIDAQAB
-----END PUBLIC KEY-----`;
    let check = encryptMI(code, publicKey);
    return {
      ts: time,
      biz_content: AES,
      sign: MD5,
      check: check,
    };
  }
  function generateRandomStr(strLength = 16) {
    let code = "";
    const chars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789";
    const charsArr = chars.split("");
    for (let i = 0; i < strLength; i++) {
      const num = Math.floor(Math.random() * charsArr.length);
      code += charsArr[num];
    }
    return code;
  }

  function encryptMI(origin, key) {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(key);
    return encrypt.encrypt(origin);
  }
  function encrypt(k, text) {
    const key = CryptoJS.enc.Utf8.parse(k);
    const encrypted = CryptoJS.AES.encrypt(text, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  }

  function startLogin(cellphone, country_code, verification_code) {
    login({
      cellphone: cellphone,
      country_code: country_code,
      verification_code: verification_code,
    }).then((res) => {
      if (res) {
        const { code, data, message } = res;
        if (code == 200) {
          if (data.login_count == 1) {
            localStorage.setItem("login", JSON.stringify(data));
            toInformation();
          } else {
            localStorage.setItem("login", JSON.stringify(data));
            setLoading(false);
            setAvatar();
          }
        } else {
          setLoading(false);
          AndMessage.error({
            content: message,
            maxCount: 1,
          });
        }
      }
    });
  }

  useEffect(() => {
    document.getElementById("captcha" + 0)?.focus();
  }, []);
  return (
    <Spin className="h-full" spinning={loading}>
      <div className="h-[100%] flex flex-col items-center">
        <span className="mt-[19px] text-[13.5897px]">
          Enter verification code
        </span>
        <span className="mt-[11.5px] scale-[calc(9.5_/_12)]">
          Enter the 4-digit code we have sent to
        </span>
        <span className="scale-[calc(9.5_/_12)]">
          {nationText} {phoneValue}
        </span>
        <div className=" w-[212px] h-[77px] border border-[#BDBDBD] rounded-[4.96774px] mt-[17px] flex items-center justify-center text-[#283ac6] text-[34.4211px]">
          {code.map((item, index) => {
            return (
              <div
                key={index}
                className="border-b border-[#BDBDBD] w-[38px] flex items-center justify-center h-[40px] ml-[5px] mr-[5px] pb-[5px]"
              >
                <input
                  id={"captcha" + index}
                  className="outline-0 w-full h-full text-center"
                  maxLength="1"
                  value={item.num}
                  onKeyDown={(event) => {
                    let value = code[index].num;
                    if (event.keyCode === 37) {
                      let dom = document.getElementById(
                        "captcha" + (activeInput - 1)
                      );
                      setactiveInput(activeInput - 1);
                      if (dom) dom.focus();
                      return;
                    }
                    if (event.keyCode === 39) {
                      let dom = document.getElementById(
                        "captcha" + (activeInput + 1)
                      );
                      setactiveInput(activeInput + 1);
                      if (dom) dom.focus();
                      return;
                    }
                    if (event.keyCode === 8 && value === "") {
                      let dom = document.getElementById(
                        "captcha" + (index - 1)
                      );
                      setactiveInput(index - 1);
                      if (dom) dom.focus();
                    }
                    if (event.keyCode !== 8 && value !== "") {
                      let dom = document.getElementById(
                        "captcha" + (index + 1)
                      );
                      setactiveInput(index + 1);
                      if (dom) dom.focus();
                    }
                  }}
                  onChange={(e) => {
                    let codes = [...code];
                    codes[index].num = e.target.value.replace(
                      /^\.+|[^\d.]/g,
                      ""
                    );
                    setCode(codes);
                    let pass = code.map((a) => a.num).join("");
                    if (pass.length === 4) {
                      setLoading(true);
                      startLogin(phoneValue, nationText, pass);
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
        <div
          className={`w-[219px] h-[30px] text-white  flex items-center justify-center rounded-[57px] m-auto mt-[22px]  cursor-pointer ${
            seconds === 0 ? "bg-[#09B251]" : "bg-[#BDBDBD]"
          }`}
          onClick={() => {
            if (seconds === 0) {
              setSeconds(60);
            }
          }}
        >
          <span className="scale-[calc(9.16_/_12)] text-[12px] font-semibold  tabular-nums">
            RESEND IN 00:
            <span>{seconds < 10 ? "0" + seconds : seconds}</span>
          </span>
        </div>
        <div className=" mb-[10px] text-[#283AC6] underline">
          <span
            className="scale-[calc(9.16_/_12)] block cursor-pointer"
            onClick={() => {
              BackAccountNumber();
            }}
          >
            Change number
          </span>
        </div>
      </div>
    </Spin>
  );
};
export default VerificationCode;
